import {supplyEventInAction} from "@/components/common/controlBar/controlBarDialog/event/washData.js";

export function washData_iconButton(walkedNode) {

  supplyEventInAction(walkedNode)
}
